<div class="alert-box">
    <div class="modal-header" translate="pleaseConfirm">
    </div>
    <div *ngIf="messageKey" class="modal-body" translate="{{messageKey}}"></div>
    <div *ngIf="message" class="modal-body" [innerHtml]="message"></div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="onCancel()" translate="cancel"></button>
        <button type="button" class="btn btn-primary" (click)="onContinue()" translate="continue"></button>
    </div>
</div>